import { useEffect, useRef } from 'react'

export const createUseFeatureDeepLink = (feature: string) => {
  return (value: string | boolean, modifier: string, ignoreFirstRender: boolean = true) => {
    const firstUpdate = useRef(true)
    useEffect(() => {
      if (ignoreFirstRender && firstUpdate.current) {
        firstUpdate.current = false
        return
      }
      const params = new URLSearchParams(window.location.search)
      params.set(`${feature}-${modifier}`, value.toString())
      window.history.replaceState({}, '', `?${params.toString()}`)

      return () => {
        params.delete(`${feature}-${modifier}`)
        window.history.replaceState({}, '', `?${params.toString()}`)
      }
    }, [value, modifier, ignoreFirstRender])
  }
}
